module.exports = __webpack_public_path__ + "static/img/logo.0e54cfd7.svg";